// @flow
import { css } from "@emotion/core";

import type {Channel} from "../../Objects";
import mq from "../../../Styles/breakpoints";

let cache = new Map();

export type Grid = {|
  styles: any,
  msRows: Map<string, number>,
  msCols: Map<string, number>
|};

export default function getGrid(rowCount: number, channels: Array<Channel>): Grid {
  let msRows = new Map();
  let msCols = new Map();

  let areaNamePattern = /\[[a-z0-9\-]+\] /ig;
  let key = rowCount + channels.join('');

  if (cache.has(key)) {
    // $FlowFixMe
    return cache.get(key);
  }

  let rows = [];
  let msRow = 1;
  for (let i = 0; i < rowCount; i++) {
    rows.push(`[time-${i}] 100px`);
    rows.push(`[expansion-${i}] auto`);

    msRows.set(`time-${i}`, msRow++);
    msRows.set(`expansion-${i}`, msRow++);

    if (i === 9) {
      rows.push(`[interrupt-morning] auto`);
      rows.push(`[break-morning] auto`);

      msRows.set(`interrupt-morning`, msRow++);
      msRows.set(`break-morning`, msRow++);
    }

    if (i === 23) {
      rows.push(`[interrupt-afternoon] auto`);
      rows.push(`[break-afternoon] auto`);

      msRows.set(`interrupt-afternoon`, msRow++);
      msRows.set(`break-afternoon`, msRow++);
    }

    if (i === 35) {
      rows.push(`[interrupt-primetime] auto`);
      rows.push(`[break-primetime] auto`);

      msRows.set(`interrupt-primetime`, msRow++);
      msRows.set(`break-primetime`, msRow++);
    }

    if (i === 45) {
      rows.push(`[interrupt-late-night] auto`);
      rows.push(`[break-late-night] auto`);

      msRows.set(`interrupt-late-night`, msRow++);
      msRows.set(`break-late-night`, msRow++);
    }
  }

  let columns = { desktop: [], mobile: [] };
  let msCol = 2;

  channels.forEach((item) => {
    let c = `channel-${item.replace(' ', '')}`;

    columns.desktop.push(`[${c}] minmax(100px,1fr)`);
    columns.mobile.push(`[${c}] calc(100% - 80px)`);
    msCols.set(c, msCol++);
  });

  let gridStyle = css`
    position: relative;
    display: -ms-grid;
    display: grid;
    z-index: 0;
    box-sizing: border-box;
    grid-gap: 1px;
    justify-items: center;
    align-items: start;
    overflow-x: auto;
    //scroll-snap-coordinate: 80px 0;
    //scroll-snap-points-x: repeat(100%);
    
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    background-color: white;
    
    grid-template-rows: ${rows.join(' ')};
    grid-template-columns: [times channels-start] 80px ${columns.mobile.join(' ')} [channels-end];
    
    -ms-grid-rows: ${rows.join(' ').replace(areaNamePattern, '')};
    -ms-grid-columns: 80px ${columns.mobile.join(' ').replace(areaNamePattern, '')};

    ${mq.large(`
      overflow: hidden;
      grid-template-columns: [times channels-start] 80px ${columns.desktop.join(' ')} [channels-end];
      
      -ms-grid-columns: 80px ${columns.desktop.join(' ').replace(areaNamePattern, '')};
    `)};
    
    @media print {
    
      // Hack that seems to successfully target Safari. This is used because
      // Safari seems to be failing to constrain the grid to the width of the
      // printed page
      @media not all and (min-resolution:.001dpcm) { 
        @media {
          max-width: 720px;  
        }
      }
      
      grid-gap: 0;
      overflow: visible;
      -ms-grid-columns: 80px 1fr 1fr 1fr 1fr;
      grid-template-columns: [times channels-start] 80px ${columns.desktop.join(' ')} [channels-end];
    }
  `;

  let entry = {
    styles: gridStyle,
    msRows,
    msCols
  };

  cache.set(key, entry);

  return entry;
}
